import { createContext } from 'react'

const PresentationWizardCtx = createContext()

export default PresentationWizardCtx
